import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  primaryText: {
    color: theme.palette.primary.main
  },

  secondaryText: {
    fontSize: '18px',
    color: theme.palette.neutral.main
  },

  uploaderIcon: {
    width:40,
    height:40,
    margin: theme.spacing(3)
  },

  errorMessage: {
    maxWidth: 'none',
    marginTop: theme.spacing(1)
  },

  errorIcon: {
    fill: theme.palette.error.main,
    marginInlineEnd: theme.spacing(1)
  },

  successIcon: {
    marginInlineEnd: theme.spacing(1)
  },

  closeIcon: {
    marginLeft:'auto',
    cursor: 'pointer'
  },

  uploadButton: {
    marginTop: theme.spacing(2)
  },

  fileBox: {
    margin: theme.spacing(1),
    padding: theme.spacing(3),
    borderRadius: '15px',
    display:'flex',
    flex:7,
    alignItems: "center",
    justifyContent: 'center',
    backgroundColor: theme.palette.neutral.white,
  },

  selectTypeFile: {
    margin: theme.spacing(1),
    padding: theme.spacing(3),
    borderRadius: '15px',
    display:'flex',
    alignItems: "center",
    flex:3,
    justifyContent: 'center',
    backgroundColor: theme.palette.neutral.white,
  },

  select: {
    width:200
  },

  rowFile: {
    display:'flex',
    flex:10,
    maxHeight: 75
  },

  column: {
    display:'flex',
    flexDirection:'column'
  },

  uploaderBox: {
    width:'auto',
    flexDirection: 'column',
    cursor:'pointer',
    display:'flex',
    alignItems: "center",
    justifyContent: 'center'
  },

  loaderIcon: {
    padding: theme.spacing(2)
  },

  cancelText: {
    color: theme.palette.primary.main,
    padding: theme.spacing(5),
    cursor: 'pointer'
  },

  dropzone : {
    display: "flex",
    flexDirection: "column",
    height: "400px",
    border: `5px dashed ${theme.palette.neutral.lighter}`,
    backgroundColor: theme.palette.neutral.lightest,
    borderRadius:'5px',
    padding: theme.spacing(2),
    overflowY: 'auto',
    overflowX: 'hidden'
  },
}))

export default useStyles
